import { Box } from "@mui/material";
import { landingPageAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import TitleSparkles from "./TitleSparkles";

const GameLogo = ({
	logoImagePathTemplate
}: {
	logoImagePathTemplate: string;
}) => {
	const { getImage } = useImagePath("cdn");

	return (
		<Box
			className="game-logo"
			sx={{
				position: "relative",
				width: { xs: "100%", sm: "63%", md: "52%", lg: "56%", xl: "33vw" }
			}}
		>
			<Box
				component="img"
				alt="Tiki Solitaire TriPeaks"
				sx={{
					content: {
						xs: `url(${getImage(logoImagePathTemplate, "small")})`,
						md: `url(${getImage(logoImagePathTemplate, "large")})`
					},
					display: "block",
					height: "auto",
					width: "100%"
				}}
			/>
			<TitleSparkles src={getImage(landingPageAssets.hero.titleBlink)} />
		</Box>
	);
};

export default GameLogo;
